(function() {
    'use strict';

a3_cabin_reports.directive('flightStatus',flightStatus);

    
    
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name flightStatus
   * @restrict EA
   * @description
   *   Implementation of flightStatus
   *
   *   Initialize the flight Status panel needs to have flight in scope
   * @example
   *   Usage:
   *   <div flight-status></div>
   * @ngInject
   */    
function flightStatus(AircaftPositionsFactory) {
    
    function link ($scope, element, attrs) {
        $scope.securitySearch = false;

        $scope.previousActualTAT = null;
        $scope.previousEstimatedTAT = null;
        $scope.previousScheduledTAT = null;
        $scope.previousDiffWithSceduled = null;

        $scope.nextActualTAT = null;
        $scope.nextEstimatedTAT = null;
        $scope.nextScheduledTAT = null;
        $scope.nextDiffWithSceduled = null;


        if($scope.flight && $scope.flight.FlightId){
            $scope.aircaftPositions =  AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);
        }

        if($scope.aircaftPositions != null){
                //TurnAroundTime();
        }
        

        function TurnAroundTime(){

            var previousTemporaryActualValue;
            var nextTemporaryActualValue;
            
            //TurnAroundTime for previous flight
            if($scope.aircaftPositions.PreviousATA && $scope.flight.ATD){
                previousTemporaryActualValue = Date.DifferenceInMinutes($scope.aircaftPositions.PreviousATA, $scope.flight.ATD);
                $scope.previousActualTAT = normalizeMins(previousTemporaryActualValue);
            }
            else if($scope.aircaftPositions.PreviousETA && $scope.flight.ETD){
                previousTemporaryActualValue = Date.DifferenceInMinutes($scope.aircaftPositions.PreviousETA, $scope.flight.ETD);
                $scope.previousEstimatedTAT = normalizeMins(previousTemporaryActualValue);
            }
            if($scope.aircaftPositions.PreviousSTA && $scope.flight.ScheduledDeparture){
                var previousTemporaryScheduledValue = Date.DifferenceInMinutes($scope.aircaftPositions.PreviousSTA, $scope.flight.ScheduledDeparture);
                $scope.previousScheduledTAT = normalizeMins(previousTemporaryScheduledValue);
                var tempDiff = previousTemporaryActualValue - previousTemporaryScheduledValue;
                //difference (mins) between Actual and Scheduled
                if(tempDiff>= -70 && tempDiff <= 70 )
                    $scope.previousDiffWithSceduled = normalizeMins(tempDiff, true);
            }

            //TurnAroundTime for next flight
            if($scope.flight.ATA && $scope.aircaftPositions.NextATD){
                nextTemporaryActualValue = Date.DifferenceInMinutes($scope.aircaftPositions.flight.ATA, $scope.aircaftPositions.NextATD);
                $scope.nextActualTAT = normalizeMins(nextTemporaryActualValue);
            }
            else if($scope.flight.ETA && $scope.aircaftPositions.NextETD){
                nextTemporaryActualValue = Date.DifferenceInMinutes($scope.aircaftPositions.flight.ETA, $scope.aircaftPositions.NextETD);
                $scope.nextEstimatedTAT = normalizeMins(nextTemporaryActualValue);
            }
            if($scope.flight.ScheduledArrival && $scope.aircaftPositions.NextSTD){
                var nextTemporaryScheduledValue = Date.DifferenceInMinutes($scope.aircaftPositions.ScheduledArrival, $scope.aircaftPositions.NextSTD);
                $scope.nextScheduledTAT = normalizeMins(nextTemporaryScheduledValue);
                var tempDiff = nextTemporaryActualValue - nextTemporaryScheduledValue;
                //difference (mins) between Actual and Scheduled
                if(tempDiff>= -70 && tempDiff <= 70 )
                    $scope.nextDiffWithSceduled = normalizeMins(tempDiff, true);
            }

        }

        function normalizeMins(diffInMins, canBeNegativeNumber){
            var returnString = "";
            //negative value - return mins
            if(canBeNegativeNumber && diffInMins < 0 ){
                returnString = diffInMins * -1 + "mins less than scheduled";
            }
            //positive value - return mins
            else if(canBeNegativeNumber)
            {
                returnString = diffInMins + "mins more than scheduled"
            }
            //positive value - return hours like "2hrs 30mins"
            else{
                returnString = Date.MinutesToString(diffInMins);
            }

            return  returnString;
        }
        function needsSecuritySearch(){
            
            if($scope.aircaftPositions.PreviousEU){
                $scope.securitySearch = false;
            }
            
            if($scope.aircaftPositions.PreviousCounty == "SWITZERLAND" 
                ||$scope.aircaftPositions.PreviousCounty == "NORWAY"
                ||$scope.aircaftPositions.PreviousCounty == "ICELAND"
                ||$scope.aircaftPositions.PreviousCounty == "MONTENEGRO"){
                $scope.securitySearch = false;
            }
            
                if($scope.aircaftPositions.PreviousCounty == "UNITED KINGDOM" 
                ||$scope.aircaftPositions.PreviousCounty == "FRANCE"){
                $scope.securitySearch = true;
            }
            
                if($scope.flight.ArrivalCountry == "TURKEY" 
                ||$scope.flight.ArrivalCountry == "EGYPT"
                ||$scope.flight.ArrivalCountry == "ISRAEL"
                ||$scope.flight.ArrivalCountry == "JORDAN"
                ||$scope.flight.ArrivalCountry == "SAUDI ARABIA"){
                $scope.securitySearch = true;
            }
            
        }

    }
    return {
			restrict: 'EA',
			terminal: true,
            templateUrl: 'views/directives/flightStatus.tpl.html',
			scope : false,
            link: link 
    }
}

})();